import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import ElementUI from 'element-ui'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import ElementLocale from 'element-ui/lib/locale'
import 'element-ui/lib/theme-chalk/index.css'
import request from './utils/request'

// 检测是否为移动端设备，如果是则跳转到手机端页面
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
if (isMobile && !localStorage.getItem('skipMobileRedirect')) {
  const mobileBaseUrl = 'https://mpay.paymmt.com'
  const currentPath = window.location.pathname || ''
  const currentQuery = window.location.search || ''

  // 将 PC 端路径映射为手机端路径
  let mobilePath = currentPath
  if (currentPath === '/register' || currentPath.startsWith('/register')) {
    mobilePath = '/pages/register/index'
  }

  window.location.href = mobileBaseUrl + mobilePath + currentQuery
}

Vue.use(ElementUI)
Vue.prototype.$http = request

// 根据当前语言设置 Element UI 的语言
const currentLang = localStorage.getItem('lang') || 'zh'
ElementLocale.use(currentLang === 'en' ? enLocale : zhLocale)

// 监听语言切换事件，同步更新 Element UI 语言
window.addEventListener('languageChanged', (event) => {
  const lang = event.detail
  ElementLocale.use(lang === 'en' ? enLocale : zhLocale)
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js